<div *transloco="let t; read: 'bpView'" class="print-container text-gray-800">
    <div *ngIf="showHeader()" class="header">
        <h1 class="text-2xl font-bold">
            {{ t('details') }}
        </h1>
    </div>
    <div class="grid grid-cols-3 pt-2">
        <!-- title -->
        <span class="border p-1 col-span-3 background text-white text-center">
            {{
                model().data.action.no +
                    ' ' +
                    model().data.action.title1 +
                    ' ' +
                    model().data.action.title2
            }}
        </span>
        <!-- description -->
        <span class="border p-1 col-span-3 text-center">
            {{ model().data.action.description }}
        </span>

        <!-- responsible -->
        <span class="border p-1 block font-semibold text-gray-600"> {{ t('responsible') }}:</span>
        <!-- technology -->
        <span class="border p-1 block font-semibold text-gray-600"> {{ t('technology') }}:</span>
        <!-- category -->
        <span class="border p-1 block font-semibold text-gray-600"> {{ t('category') }}:</span>

        <!-- responsible -->
        <span class="border p-1 block">{{ responsible }}</span>
        <!-- technology -->
        <span class="border p-1 block">{{ technology }}</span>
        <!-- category -->
        <span class="border p-1 block">{{ model().category }}</span>
    </div>
    <div class="border grid grid-cols-3 mt-10 mb-2 text-left">
        <!-- transaction -->
        @if (transaction) {
            <span class="border p-1 block font-semibold text-gray-600">
                {{ t('transaction') }}:</span
            >
            <span class="border p-1 block col-span-2">{{ transaction }}</span>
        }

        <!-- dependencies -->
        <span class="border p-1 block font-semibold text-gray-600"> {{ t('dependencies') }}:</span>
        <ul class="border p-1 pl-6 list-disc col-span-2">
            @if (model().data.action.dependencies.length > 0) {
                <li
                    *ngFor="let dependency of model().data.action.dependencies; trackBy: trackByFn"
                    [innerHTML]="getDependency(dependency.id)">
                </li>
            } @else {
                <span> - </span>
            }
        </ul>

        <!-- inputs -->
        <span class="border p-1 block font-semibold text-gray-600"> {{ t('inputs') }}:</span>
        <ul class="border p-1 pl-6 list-disc col-span-2">
            @if (model().data.input.length > 0) {
                <li
                    *ngFor="let input of model().data.input; trackBy: trackByFn"
                    [innerHTML]="getEntry(input)">
                </li>
            } @else {
                <span> - </span>
            }
        </ul>

        <!-- outputs -->
        <span class="border p-1 block font-semibold text-gray-600"> {{ t('outputs') }}:</span>
        <ul class="border p-1 pl-6 list-disc col-span-2">
            @if (model().data.output.length > 0) {
                <li
                    *ngFor="let input of model().data.output; trackBy: trackByFn"
                    [innerHTML]="getEntry(input)">
                </li>
            } @else {
                <span> - </span>
            }
        </ul>
    </div>
</div>
